module.exports = "//cdn.mxpnl.com/static/asset-cache/ddba4d4ae0ebd6f22c46d990c5afe14d/iron/common/widgets/intro/images/circle.svg";